import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Book from './views/Book.vue'
import Chapter from './views/Chapter.vue'
import Reply from './views/Reply.vue'
import Catalog from './views/Catalog.vue'
import Classify from './views/Classify.vue'
import Rank from './views/Rank.vue'
import Finish from './views/Finish.vue'
import Free from './views/Free.vue'
import Login from './views/Login.vue'
import Search from './views/Search.vue'
import Logindo from './components/login/Logindo'
import Reg from './components/login/Reg'
import Othen from './components/login/Othen'
import Forget from './components/login/Forget'
import Mess from './components/login/Mess'
import Wechat from './components/login/Wechat'
import Firstcharge from './components/activity/Firstcharge'
import Autumn from './components/activity/Autumn'
import Eleven from './components/activity/Eleven'
import Twelve from './components/activity/Twelve'
import Yuandan from './components/activity/Yuandan'
import Year from './components/activity/Year'
import Lover from './components/activity/Lover'
import Woman from './components/activity/Woman'
import Annual from './components/activity/Annual'
import Lonterm from './components/activity/Lonterm'
import Qingming from './components/activity/Qingming'
import Wuyi from './components/activity/Wuyi'
import Liu from './components/activity/Liu'
import Duanwu from './components/activity/Duanwu'
import Weekend from './components/activity/Weekend'
import Guoqing from './components/activity/Guoqing'
import Ssy from './components/activity/Ssy'

//quick
import Toapp from './components/quick/Toapp'
import Quickyear from './components/quick/Year'
import Dingzi from  './components/quick/Dingzi'
import Qiudong from  './components/quick/Qiudong'
import Quickssy from  './components/quick/Ssy'
import Quickyd from  './components/quick/Yuandan'
import Currency from  './components/quick/Currency'




import Service from './views/Service'
import Privacy from './views/Privacy'
import Recharge from './views/Recharge'
import Rechargelist from './views/Rechargelist'
import Classifybook from './views/Classifybook'
import Subscribe from './views/Subscribe'
import Subscribelist from './views/Subscribelist'
import History from './views/History'
import Sneak from './views/Sneak'
import Views from './views/Views'
import Code from './views/Code'
import Codes from './views/Codes'
import Follow from './views/Follow'
import Bill from './views/Bill'
import Signin from './views/Signin'
import Keep from './views/Keep'
import Empty from './views/Empty'
import Bindphone from './views/Bindphone'
import Tiaozhuan from './views/Tiaozhuan'
import Mail from './views/Mail'
import Mailinfo from './views/Mailinfo'
import Next from './views/Next'
import Luck from "./views/Luck";

import User from './views/User'
import Customerservice from './components/user/Customerservice'
import Password from './components/user/Password'
import Active64 from "./components/quick/Active64";
import Active65 from "./components/quick/Active65";

import Newyear from "./components/quick/Newyear";
import Activity1 from "./components/activity/Activity1";
import Activity2 from "./components/activity/Activity2";
import Test from "./views/Test";
import Active66 from "./components/quick/Active66";
import Active67 from "./components/quick/Active67";
import Activity3 from "./components/activity/Activity3";
import Activity5 from "./components/activity/Activity5";
import Active68 from "./components/quick/Active68";
import Aircraft from "./views/Aircraft";
import Activity4 from "@/components/activity/Activity4";
import Active69 from "@/components/quick/Active69";
import Active70 from "@/components/quick/Active70";
import Active71 from "@/components/quick/Active71";
import Active72 from "@/components/quick/Active72";

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'Home', component: Home},
    {path: '/book/:wid', name: 'Book', component: Book},
    {path: '/chapter/:wid/:cid', name: 'Chapter', component: Chapter},
    {path: '/follow/:wid/:cid', name: 'Follow', component: Follow},
    {path: '/reply/:wid/:author?', name: 'Reply', component: Reply},
    {path: '/catalog/:wid', name: 'Catalog', component: Catalog},
    {path: '/classify', name: 'Classify', component: Classify},
    {path: '/rank', name: 'Rank', component: Rank},
    {path: '/finish', name: 'Finish', component: Finish},
    {path: '/free', name: 'Free', component: Free},
    {path: '/service', name: 'Service', component: Service},
    {path: '/privacy', name: 'Privacy', component: Privacy},
    {path: '/recharge', name: 'Recharge', component: Recharge},
    {path: '/rechargelist', name: 'Rechargelist', component: Rechargelist},
    {path: '/subscribe', name: 'Subscribe', component: Subscribe},
    {path: '/bindphone', name: 'Bindphone', component: Bindphone},
    {path: '/subscribelist/:wid', name: 'Subscribelist', component: Subscribelist},
    {path: '/history', name: 'History', component: History},
    {path: '/bill', name: 'Bill', component: Bill},
    {path: '/keep', name: 'Keep', component: Keep},
    {path: '/classifybook/:cid', name: 'Classifybook', component: Classifybook},
    {path: '/firstcharge', name: 'Firstcharge', component: Firstcharge},
    {path: '/autumn/:id', name: 'Autumn', component: Autumn},
    {path: '/Eleven', name: 'Eleven', component: Eleven},
    {path: '/twelve', name: 'Twelve', component: Twelve},
    {path: '/tiaozhuan/:wid', name: 'Tiaozhuan', component: Tiaozhuan},
    {path: '/yuandan', name: 'Yuandan', component: Yuandan},
    {path: '/year', name: 'Year', component: Year},
    {path: '/lover', name: 'Lover', component: Lover},
    {path: '/woman', name: 'Woman', component: Woman},
    {path: '/annual', name: 'Annual', component: Annual},
    {path: '/lonterm', name: 'Lonterm', component: Lonterm},
    {path: '/Qingming', name: 'Qingming', component: Qingming},
    {path: '/Guoqing', name: 'Guoqing', component: Guoqing},
    {path: '/wuyi', name: 'Wuyi', component: Wuyi},
    {path: '/liu', name: 'Liu', component: Liu},
    {path: '/duanwu', name: 'Duanwu', component: Duanwu},
    {path: '/ssy', name: 'Ssy', component: Ssy},
    {path: '/weekend/:aid?', name: 'Weekend', component: Weekend},
    {path: '/next/:bid/:cid', name: 'Next', component: Next},
    {path: '/test', name: 'Test', component: Test},

    {path: '/sneak/:encode', name: 'Sneak', component: Sneak},
    {path: '/views/:id', name: 'Views', component: Views},
    {path: '/code/:id', name: 'Code', component: Code},
    {path: '/codes/:id', name: 'Codes', component: Codes},
    {path: '/empty/:sex/:wid', name: 'Empty', component: Empty},

    {path: '/login', name: 'Login', component: Login, redirect : Logindo, children : [
        {path:'/login/logindo',name:'Logindo',component:Logindo},
        {path:'/login/reg',name:'Reg',component:Reg},
        {path:'/login/forget',name:'Forget',component:Forget},
        {path:'/login/othen',name:'Othen',component:Othen},
        {path:'/login/mess',name:'Mess',component:Mess},
        {path:'/login/wechat',name:'Wechat',component:Wechat},
      ]
    },
    {path: '/search', name: 'Search', component: Search},

      {path: '/user', name: 'User', component: User},
      {path: '/mail', name: 'Mail', component: Mail},
      {path: '/mailinfo/:id', name: 'Mailinfo', component: Mailinfo},
      {path: '/signin', name: 'Signin', component: Signin},
      {path: '/customerservice', name: 'Customerservice', component: Customerservice},
      {path: '/password', name: 'Password', component: Password},

      {path: '/toapp', name: 'Toapp', component: Toapp},
      {path: '/quickyear', name: 'Quickyear', component: Quickyear},
      {path: '/dingzi', name: 'Dingzi', component: Dingzi},
      {path: '/qiudong', name: 'Qiudong', component: Qiudong},
      {path: '/quickssy', name: 'Quickssy', component: Quickssy},
      {path: '/quickyd', name: 'Quickyd', component: Quickyd},
      {path: '/currency/:id', name: 'Currency', component: Currency},
      {path: '/Active64', name: 'Active64', component: Active64},
      {path: '/Active65', name: 'Active65', component: Active65},
      {path: '/active66', name: 'Active66', component: Active66},
      {path: '/active67', name: 'Active67', component: Active67},
      {path: '/active68', name: 'Active68', component: Active68},
      {path: '/active69', name: 'Active69', component: Active69},
      {path: '/active70', name: 'Active70', component: Active70},
      {path: '/active71', name: 'Active71', component: Active71},
      {path: '/active72', name: 'Active72', component: Active72},
      {path: '/luck', name: 'Luck', component: Luck},
      {path: '/quicknewyear', name: 'Newyear', component: Newyear},
      {path: '/activity1', name: 'Activity1', component: Activity1},
      {path: '/activity2', name: 'Activity2', component: Activity2},
      {path: '/activity3', name: 'Activity3', component: Activity3},
      {path: '/activity4', name: 'Activity4', component: Activity4},
      {path: '/activity5', name: 'Activity5', component: Activity5},
      {path: '/aircraft/:bookid/:chapterid', name: 'Aircraft', component: Aircraft},


  ]
})


    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    if(userInfo){
        let length = Object.keys(userInfo);
        if(length.length){
            store.dispatch('setUserInfo',userInfo);
        }
    }

router.beforeEach((to,from,next) => {
    console.log(to.name)
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS && to.path !== location.pathname) {
        // location.assign(to.fullPath)
    }

    let userInfo = store.getters.getUserInfo;

    let ua = window.navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)){
        if(userInfo.id){
            next();
        }else{
            if(to.name == 'Login' || to.name == 'Logindo'){
                next();
            }else{

                let userInfo = store.getters.getUserInfo;
                if(userInfo.id){
                    next();
                }else{
                    next({
                        name:'Login',
                        replace : true,
                        query:{cburl:to.path}
                    })
                }


            }

        }
    }else{
        let names = [
            'User','Recharge','History','Keep','Aircraft'
        ];
        if(names.indexOf(to.name) > -1){
            if(userInfo.id){
                next();
            }else{
                next({
                    name:'Login',
                    replace : true,
                    query:{cburl:to.path}
                });
            }

        }else{
            next();
        }
    }


})


export default router;
